export interface IBenefitCardEmployee {
  id: number;
  employeeNumber: string;
  firstName: string;
  lastName: string;
  personalEmail: string;
  mealCard: {
    id: number;
    balance: number;
    type: {
      id: number;
      name: string;
    }
  } 
}